export default "__VITE_ASSET__CDdZtjnI__"